//$(function() {
$.noConflict();
jQuery(document).ready(function ($) {
  var lugar = url.getParameter("lugar");
  var centro = [];
  switch (lugar) {
    case "tlaltenango":
      //San Mateo Tlaltenango
      centro = [19.3421333, -99.2795806];
      centro = [19.316355, -99.306046];
      break;
    case "santa-fe":
      //Barranca de Tacubaya
      centro = [19.382987, -99.241839];
      break;
    case "santa-rosa":
      //Santa Rosa Xochiac
      centro = [19.3263625, -99.28753];
      break;
    default:
      lugar = "chimalpa";
      //San Pablo Chimalpa
      centro = [19.3532222222, -99.3179666667];
      break;
  }

  var zoom = 16;
  var mapa = null;
  var patron02 = null;
  var patron11 = null;
  var patron12 = null;

  var estiloSuelo = {
    color: "#00ff00",
    weight: 1,
    opacity: 0.5,
    stroke: true,
  };

  var estiloColonias = {
    color: "#3b3b3b",
    weight: 1,
    opacity: 1,
    stroke: true,
    fillOpacity: 0,
    dashArray: "15, 10, 5, 10",
  };

  var estiloRios = {
    color: "#4dd6ff",
    weight: 4,
    stroke: true,
  };

  var capaSuelo = null;
  var arregloForestal = [];
  var arregloColonias = [];
  var capaColonias = null;
  var arregloManantiales = [];

  var capasFauna = [];
  var capasFlora = [];
  var capasForestal = [];
  var capasHidrico = [];

  function setup() {
    var arregloURLs = [];
    switch (lugar) {
      case "tlaltenango":
        arregloURLs = [
          "json/tlaltenango/suelo.json",
          "json/tlaltenango/zona.json",
          "json/tlaltenango/rios-01.json",
          "json/tlaltenango/rios-02.json",
          "json/tlaltenango/parajes.json",
        ];
        break;
      case "santa-fe":
        arregloURLs = [
          "json/santa-fe/zona.json",
          "json/santa-fe/rios.json",
          "json/santa-fe/manantial.json",
          "json/santa-fe/vegetacion.json",
          "json/santa-fe/puntos.json",
        ];
        break;
      case "santa-rosa":
        arregloURLs = ["json/santa-rosa/colonias.json"];
        break;
      default:
        arregloURLs = [
          "json/chimalpa/borracho.json",
          "json/chimalpa/colonias.json",
          "json/chimalpa/flora.json",
          "json/chimalpa/forestal.json",
          "json/chimalpa/manantiales.json",
          "json/chimalpa/oyametitla.json",
          "json/chimalpa/suelo.json",
        ];
        break;
    }

    //console.log("arregloURLs");
    //console.log(arregloURLs);
    var n = 0;
    var i = 0;
    var promesas = [];
    setMapa();
    setPatrones();
    n = arregloURLs.length;
    for (i = 0; i < n; i++) {
      promesas.push($.ajax(arregloURLs[i]));
    }
    Promise.all(promesas).then(function (values) {
      switch (lugar) {
        case "tlaltenango":
          var suelo = values[0];
          var colonias = values[1];
          var rios01 = values[2];
          var rios02 = values[3];
          var puntos = values[4];
          setSuelo(suelo);
          setColonias(colonias);
          setRio(rios01);
          setRio(rios02);
          setPuntos(puntos);
          //TODO: Falta agregar la fauna
          break;
        case "santa-fe":
          var colonias = values[0];
          var rios = values[1];
          var manantial = values[2];
          var flora = values[3];
          var puntos = values[4];
          setColonias(colonias);
          setRio(rios);
          //setManantiales(manantial);
          //TODO: Procesar archivo de manantial
          //setMarcadores(flora);
          //TODO: Procesar archivo de flora
          setPuntos(puntos);
          break;
        case "santa-rosa":
          //var colonias = values[0];
          //setColonias(colonias);
          break;
        default:
          var borracho = values[0];
          var colonias = values[1];
          var flora = values[2];
          var forestal = values[3];
          var manantiales = values[4];
          var oyametitla = values[5];
          var suelo = values[6];
          setSuelo(suelo);
          setColonias(colonias);
          setRio(oyametitla);
          setRio(borracho);
          setMarcadoresForestal(forestal);
          setMarcadoresFlora(flora);
          setManantiales(manantiales);
          //setPuntos(puntos);
          //setToponimos(toponimos);
          break;
      }
      escuchaZoom();
      main();
    });
  }

  function setMapa() {
    mapa = L.map("mapa", {
      center: centro,
      zoom: zoom,
      minZoom: 14,
      maxZoom: 18,
    });
    L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
      attribution:
        '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
    }).addTo(mapa);
  }

  function setPatrones() {
    patron02 = new L.StripePattern({
      angle: 315,
      weight: 1,
      spaceWeight: 1,
      color: "#000000",
      opacity: 1,
    }).addTo(mapa);

    var shape = new L.PatternRect({
      x: 0,
      y: 0,
      width: 10,
      height: 5,
      rx: 0,
      ry: 0,
      fill: true,
      color: "#ffc980",
    });

    patron11 = new L.Pattern({ width: 20, height: 20, fillOpacity: 1 });
    patron11.addShape(shape);
    patron11.addTo(mapa);

    patron12 = new L.StripePattern({
      angle: 225,
      weight: 1,
      spaceWeight: 1,
      color: "#000000",
      opacity: 1,
    }).addTo(mapa);
  }

  function setColonias(objeto) {
    //console.log(objeto);
    //console.log(objeto.features);
    capaColonias = L.geoJSON(objeto.features, {
      style: estiloColonias,
    }) /*
      .bindPopup(function (layer) {
        return layer.feature.properties.NOMCOLONIA;
      })*/
      .addTo(mapa);
    //console.log("listo!");
    //console.log(capaColonias);
  }

  function setRio(objeto) {
    L.geoJSON(objeto.features, {
      style: estiloRios,
    })
      .bindPopup(function (layer) {
        //console.log(layer.feature.properties); //TODO: Remover
        return layer.feature.properties.NOMBRE;
      })
      .addTo(mapa);
  }

  function checaFoto(o) {
    return o.ort.foto.indexOf("no_disponible") < 0;
  }

  function setMarcadoresForestal(objeto) {
    objeto.features = objeto.features.filter(checaFoto);
    var estilo = {
      radius: 4,
      fillColor: "#4dad02",
      color: "#4dad02",
      weight: 1,
      opacity: 1,
      fillOpacity: 1,
    };
    var capa = L.geoJSON(objeto.features, {
      pointToLayer: function (feature, latlng) {
        var marcador = L.circleMarker(latlng, estilo)
          .bindPopup(feature.ort.nombre)
          .on("mouseover", function (ev) {
            ev.target.openPopup();
          })
          .on("mouseout", function (ev) {
            ev.target.closePopup();
          })
          .on("click", function (ev) {
            ev.target.closePopup();
            setTarjeta(ev.target.feature.ort);
          })
          .addTo(mapa);
        capasForestal.push(marcador);
        return marcador;
      },
    }).addTo(mapa);
  }

  function setMarcadoresFlora(objeto) {
    objeto.features = objeto.features.filter(checaFoto);
    var estilo = {
      radius: 4,
      fillColor: "#bc08a3",
      color: "#bc08a3",
      weight: 1,
      opacity: 1,
      fillOpacity: 1,
    };
    var capa = L.geoJSON(objeto.features, {
      pointToLayer: function (feature, latlng) {
        var marcador = L.circleMarker(latlng, estilo)
          .bindPopup(feature.ort.nombre)
          .on("mouseover", function (ev) {
            ev.target.openPopup();
          })
          .on("mouseout", function (ev) {
            ev.target.closePopup();
          })
          .on("click", function (ev) {
            ev.target.closePopup();
            setTarjeta(ev.target.feature.ort);
          })
          .addTo(mapa);
        capasFlora.push(marcador);
      },
    }).addTo(mapa);
  }

  function setMarcadoresFauna(objeto) {
    objeto.features = objeto.features.filter(checaFoto);
    var estilo = {
      radius: 4,
      fillColor: "#c99106",
      color: "#c99106",
      weight: 1,
      opacity: 1,
      fillOpacity: 1,
    };
    var capa = L.geoJSON(objeto.features, {
      pointToLayer: function (feature, latlng) {
        var marcador = L.circleMarker(latlng, estilo)
          .bindPopup(feature.ort.nombre)
          .on("mouseover", function (ev) {
            ev.target.openPopup();
          })
          .on("mouseout", function (ev) {
            ev.target.closePopup();
          })
          .on("click", function (ev) {
            ev.target.closePopup();
            setTarjeta(ev.target.feature.ort);
          })
          .addTo(mapa);
        capasFauna.push(marcador);
      },
    }).addTo(mapa);
  }

  function setMarcadores(objeto) {
    //objeto.features = objeto.features.filter(checaFoto);

    var marcadorFlora = {
      radius: 4,
      fillColor: "#bc08a3",
      color: "#bc08a3",
      weight: 1,
      opacity: 1,
      fillOpacity: 1,
    };

    var marcadorForestal = {
      radius: 4,
      fillColor: "#4dad02",
      color: "#4dad02",
      weight: 1,
      opacity: 1,
      fillOpacity: 1,
    };

    var marcadorHidrico = {
      radius: 4,
      fillColor: "#00c4b5",
      color: "#00c4b5",
      weight: 1,
      opacity: 1,
      fillOpacity: 1,
    };

    var capa = L.geoJSON(objeto.features, {
      pointToLayer: function (feature, latlng) {
        var estilo = null;
        switch (feature.ort.recurso) {
          case "flora":
            estilo = marcadorFlora;
            break;
          case "forestal":
            estilo = marcadorForestal;
            break;
          default:
            estilo = marcadorHidrico;
            break;
        }
        var c = L.circleMarker(latlng, estilo)
          .bindPopup(feature.ort.nombre)
          .on("mouseover", function (ev) {
            ev.target.openPopup();
          })
          .on("mouseout", function (ev) {
            ev.target.closePopup();
          })
          .on("click", function (ev) {
            ev.target.closePopup();
            setTarjeta(ev.target.feature.ort);
          })
          .addTo(mapa);
        arregloForestal.push(c);
        return c;
      },
    }).addTo(mapa);
  }

  function setTarjeta(ort) {
    var arreglo = Object.entries(ort);
    var id = null;
    var valor = null;
    arreglo.forEach(function (dupla) {
      id = "#" + dupla[0];
      valor = dupla[1];
      //console.log(id + ": " + valor);
      switch (id) {
        case "#recurso":
        case "#nombre":
        case "#zona":
        case "#categoria":
          $(id, parent.document).html(valor);
          break;
        case "#nombre_cientifico":
        case "#ubicacion":
        case "#conservacion_y_usos":
        case "#tensiones_riesgos_y_vulnerabilidades":
        case "#generalidades":
        case "#testimonio_de_la_comunidad":
          var titulo = id + "_titulo";
          $(id, parent.document).html(valor);
          if (valor == "") {
            $(id, parent.document).hide();
            $(titulo, parent.document).hide();
          } else {
            $(id, parent.document).show();
            $(titulo, parent.document).show();
          }
          break;
        case "#grado_de_conservacion":
          //PENDING, es lo de las barritas
          break;
        case "#foto":
          var img = $(id + " img", parent.document);
          img.attr("sizes", null);
          img.attr("srcset", null);
          img.attr("src", "/mapa/" + valor);
          img.attr("title", ort.nombre + " en " + ort.zona);
          img.attr("alt", ort.nombre + " en " + ort.zona);
          break;
        default:
          break;
      }
    });
  }

  function setManantiales(objeto) {
    var IconoManantial = L.Icon.extend({
      options: {
        iconUrl: "img/iconos/manantial.png",
        iconSize: [21, 21],
        iconAnchor: [11, 11],
        popupAnchor: [0, 0],
      },
    });
    objeto.features.forEach(function (feature) {
      //console.log(feature);
      var icono = new IconoManantial();
      var c = L.marker(feature.geometry.coordinates.reverse(), {
        icon: icono,
      })
        .bindPopup(feature.ort.nombre)
        .on("mouseover", function (ev) {
          ev.target.openPopup();
        })
        .on("mouseout", function (ev) {
          ev.target.closePopup();
        })
        .on("click", function (ev) {
          ev.target.closePopup();
          setTarjeta(feature.ort);
        })
        .addTo(mapa);
      capasHidrico.push(c);
      return c;
    });
  }

  function setPuntos(objeto) {
    L.geoJSON(objeto.features)
      .bindPopup(function (layer) {
        //console.log(layer.feature.properties); //TODO: Remover
        return (
          layer.feature.properties.NOM_MAYUSC || layer.feature.properties.Name
        );
      })
      .addTo(mapa);
  }

  function setSuelo(objeto) {
    //console.log("setSuelo");
    //console.log(objeto);
    //console.log(objeto.features);
    L.geoJSON(objeto.features, {
      style: setColorSuelo,
    })
      .bindPopup(function (layer) {
        return layer.feature.properties.DESC_;
      })
      .addTo(mapa);
  }

  window.coloresSuelo = []; //TODO: Remover este arreglo cuando se termine todo
  function getColorSuelo(id) {
    var color = "#ffffff";
    switch (id) {
      case 1:
        color = "#ffd521";
        break;
      case 2:
        color = "#cdcdcd";
        break;
      case 3:
        color = "#c1f7a8";
        break;
      case 4:
        color = "#6d8b5f";
        break;
      case 5:
        color = "#badd8c";
        break;
      case 6:
        color = "#8cc63f";
        break;
      case 7:
        color = "#ceecce";
        break;
      case 8:
        color = "#8eb78e";
        break;
      case 9:
        color = "#d1ca95";
        break;
      case 10:
        color = "#948e5c";
        break;
      case 13:
        color = "#666666";
        break;
      case 14:
        color = "#fffda5";
        break;
      default:
        window.coloresSuelo.push(id);
        break;
    }
    return color;
  }

  function setColorSuelo(feature) {
    var estilo = { weight: 1, opacity: 0.65, fillOpacity: 0.65 };
    switch (feature.properties.ID) {
      case 2:
        estilo.fillPattern = patron02;
        estilo.fillOpacity = 0.6;
        break;
      case 11:
        estilo.fillPattern = patron11;
        estilo.fillOpacity = 1;
        estilo.opacity = 1;
        break;
      case 12:
        estilo.fillPattern = patron12;
        estilo.fillOpacity = 0.8;
        break;
      default:
        estilo.fillColor = getColorSuelo(feature.properties.ID);
        estilo.color = getColorSuelo(feature.properties.ID);
        break;
    }
    return estilo;
  }

  function setToponimos(objeto) {
    L.geoJSON(objeto.features)
      .bindPopup(function (layer) {
        return layer.feature.properties.Name;
      })
      .addTo(mapa);
  }

  function escuchaZoom() {
    mapa.on("zoomend", function (ev) {
      var zoom = mapa.getZoom();
      var radio = 0;
      var iconSize = [];
      var iconAnchor = [];
      switch (zoom) {
        case 14:
          radio = 1;
          iconSize = [7, 7];
          iconAnchor = [4, 4];
          break;
        case 15:
          radio = 3;
          iconSize = [15, 15];
          iconAnchor = [8, 8];
          break;
        case 16:
          radio = 5;
          iconSize = [25, 25];
          iconAnchor = [13, 13];
          break;
        case 17:
        case 18:
          radio = 7;
          iconSize = [33, 33];
          iconAnchor = [17, 17];
          break;
        default:
          radio = 4;
          iconSize = [21, 21];
          iconAnchor = [11, 11];
          break;
      }
      capasFlora.forEach(function (marcador) {
        marcador.setRadius(radio);
      });
      capasForestal.forEach(function (marcador) {
        marcador.setRadius(radio);
      });
      capasFauna.forEach(function (marcador) {
        marcador.setRadius(radio);
      });
      capasHidrico.forEach(function (marcador) {
        var icon = marcador.options.icon;
        icon.options.iconSize = iconSize;
        icon.options.iconAnchor = iconAnchor;
        marcador.setIcon(icon);
      });
    });
  }

  function main() {
    setEventos();
  }

  var flagHidricos = true;
  function toggleHidricos() {
    flagHidricos = !flagHidricos;
    if (flagHidricos === true) {
      capasHidrico.forEach(function (marcador, i) {
        mapa.addLayer(marcador);
      });
    } else {
      capasHidrico.forEach(function (marcador, i) {
        mapa.removeLayer(marcador);
      });
    }
  }

  var flagForestales = true;
  function toggleForestales() {
    flagForestales = !flagForestales;
    if (flagForestales === true) {
      capasForestal.forEach(function (marcador, i) {
        mapa.addLayer(marcador);
      });
    } else {
      capasForestal.forEach(function (marcador, i) {
        mapa.removeLayer(marcador);
      });
    }
  }

  var flagFloras = true;
  function toggleFloras() {
    flagFloras = !flagFloras;
    if (flagFloras === true) {
      capasFlora.forEach(function (marcador, i) {
        mapa.addLayer(marcador);
      });
    } else {
      capasFlora.forEach(function (marcador, i) {
        mapa.removeLayer(marcador);
      });
    }
  }

  var flagFaunas = true;
  function toggleFaunas() {
    flagFaunas = !flagFaunas;
    if (flagFaunas === true) {
      capasFauna.forEach(function (marcador, i) {
        mapa.addLayer(marcador);
      });
    } else {
      capasFauna.forEach(function (marcador, i) {
        mapa.removeLayer(marcador);
      });
    }
  }

  function setEventos() {
    $("#toggleHidricos", parent.document).click(function () {
      toggleHidricos();
    });
    $("#toggleForestales", parent.document).click(function () {
      toggleForestales();
    });
    $("#toggleFloras", parent.document).click(function () {
      toggleFloras();
    });
    $("#toggleFaunas", parent.document).click(function () {
      toggleFaunas();
    });
  }

  window.Mapa = {
    toggleHidricos: toggleHidricos,
    toggleForestales: toggleForestales,
    toggleFloras: toggleFloras,
    toggleFaunas: toggleFaunas,
  };

  setup();
});
